<template>
  <div class="mall-my-filter">
    <div class="mall-my-filter__presets" role="group" aria-label="기간 빠른 선택">
      <button
        v-for="item in presets"
        :key="item.key"
        type="button"
        :class="{ 'is-active': preset === item.key }"
        @click="$emit('preset', item.key)"
      >
        {{ item.label }}
      </button>
    </div>

    <div class="mall-my-filter__row">
      <label class="mall-my-filter__date">
        <span>시작일</span>
        <input
          :value="fromDate"
          type="date"
          @input="$emit('update:fromDate', ($event.target as HTMLInputElement).value)"
        />
      </label>
      <label class="mall-my-filter__date">
        <span>종료일</span>
        <input
          :value="toDate"
          type="date"
          @input="$emit('update:toDate', ($event.target as HTMLInputElement).value)"
        />
      </label>
      <label v-if="searchable" class="mall-my-filter__search">
        <span>검색</span>
        <input
          :value="keyword"
          type="search"
          :placeholder="placeholder"
          @input="$emit('update:keyword', ($event.target as HTMLInputElement).value)"
          @keydown.enter.prevent="$emit('search')"
        />
      </label>
      <div class="mall-my-filter__actions">
        <button type="button" class="mall-my-filter__btn" @click="$emit('search')">조회</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DATE_PRESETS, type DatePresetKey } from '@/utils/dateInput'

withDefaults(
  defineProps<{
    fromDate: string
    toDate: string
    keyword?: string
    preset: DatePresetKey
    placeholder?: string
    searchable?: boolean
  }>(),
  {
    keyword: '',
    placeholder: '검색어',
    searchable: true,
  },
)

defineEmits<{
  'update:fromDate': [value: string]
  'update:toDate': [value: string]
  'update:keyword': [value: string]
  preset: [key: DatePresetKey]
  search: []
}>()

const presets = DATE_PRESETS
</script>

<style lang="scss" src="./MallMyFilterBar.scss"></style>
